import {Field} from "formik";
import {getImage, sliceText} from "../../utils/utils";
import accountSVG from "../../images/account.svg";
import React from "react";
import styled from "styled-components";
import SearchBarUserName from "../search-bar/SearchBarUserName";
import useFilterUser from "../../custom-hooks/useFilterUser";
import useSortItems from "../../custom-hooks/useSortItems";

const SelectUserInputFormik = ({
                                   pilotId,
                                   users,
                                   name = "pilotId",
                                   label = "pilote",
                                   displayLabel = true,
                                   initialUser}) => {


    const {sortOneItemTopOfTheList} = useSortItems()
    const sortedUsers = sortOneItemTopOfTheList(users, initialUser)

    const {
        getFullNameNoWhiteSpace,
        getFullNameInverseNoWhiteSpace,
        getQueryNoWhiteSpace,
        query,
        setQuery
    } = useFilterUser(users)
    return (
        <div>
            <InputPilot>
                {displayLabel &&
                <label> Choisir un {label === "sponsor" ? "sponsor *" : label + " * "}</label>
                }
                <SearchBarUserName
                    setQuery={setQuery}
                    name={'utilisateur'}
                />
                <Wrapper>
                    {sortedUsers
                        .filter(u =>
                            u.firstName.toLowerCase().includes(query.toLowerCase()) ||
                            u.lastName.toLowerCase().includes(query.toLowerCase()) ||
                            getFullNameNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query)) ||
                            getFullNameInverseNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query))
                        )
                        .map(user => (
                            <InputsContainer key={user.id + '/' + user.name}>
                                <label>
                                    <Field
                                        type={"radio"}
                                        name={name}
                                        value={user.id}
                                        checked={user?.id?.toString() === pilotId?.toString()}
                                    />
                                    <Card className={'user-card-input'}>
                                        <img src={getImage(user.photo, accountSVG)} alt={""}/>
                                        <p><span>{user.firstName} </span> <span> {sliceText(user.lastName, 9)}</span>
                                        </p>
                                    </Card>

                                </label>
                            </InputsContainer>
                        ))}
                </Wrapper>
            </InputPilot>
        </div>
    )
}

const InputPilot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  padding: 0.5em;
  border-radius: 10px;
  overflow-x: hidden;

  .wrapper-selector {
    width: 30em;
  }

  label {
    font-weight: 700;
  }
`
const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-width: 5rem;
  padding: 0.5rem;
  border-radius: 12px;
  cursor: pointer;
  background-color: var(--color-white);

  :hover {
    background: var(--color-purple-06);

    p > span {
      color: var(--color-white)
    }
  }

  img {
    width: 2.5em;
    height: 2.5em;
    object-fit: cover;
    border-radius: 50%;
  }

  p {
    display: flex;
    flex-direction: column;
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    height: 50%;
    width: 100%;
  }
`

const InputsContainer = styled.div`
  label > input {
    opacity: 0;
    display: none;
  }

  label > input:checked + .user-card-input {
    background-color: var(--color-purple-06);

    p > span {
      color: var(--color-white)
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  height: 100px;
`

export default SelectUserInputFormik